import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const GROUPS = [["large", "Large playgroup", "keep-color grp-lg"], ["small", "Small playgroup", "keep-color grp-sm"],
  ["pp", "Private play", "keep-color grp-pp"], [null, "No group flag", "border-gray-200 text-gray-600 bg-gray-50"]];

const Section = ({ title, dogs, svc }) => {
  if (!dogs.length) return null;
  return (
    <div className="space-y-2" data-testid={`inbuilding-section-${svc}`}>
      <div className="text-sm font-extrabold text-gray-900">{title} <span className="text-gray-400 font-bold">{dogs.length}</span></div>
      {GROUPS.map(([key, label, cls]) => {
        const list = dogs.filter((d) => (d.group || null) === key);
        if (!list.length) return null;
        return (
          <div key={label} className="pl-1" data-testid={`inbuilding-${svc}-${key || "none"}`}>
            <div className="text-[11px] font-bold uppercase tracking-wide text-gray-500 mb-1">{label} · {list.length}</div>
            <div className="flex flex-wrap gap-1.5">
              {list.map((d, i) => (
                <span key={i} className={`text-xs font-semibold border rounded-full px-2 py-0.5 ${cls}`} title={[d.room, d.out_time && `out ${d.out_time}`].filter(Boolean).join(" · ")}>
                  {d.name}{d.out_today && <span className="opacity-60"> · out {d.out_time}</span>}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

// List of every dog checked in at Gingr right now, Board/Daycare → Lg/Sm/PP.
export const InBuildingDialog = ({ open, onOpenChange, dogs = [] }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="ops-v3 max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="inbuilding-dialog">
      <DialogHeader>
        <DialogTitle>Checked in now — {dogs.length} dog{dogs.length === 1 ? "" : "s"}</DialogTitle>
        <DialogDescription>Checked in at Gingr and not yet checked out. Dogs going home today show their pickup time.</DialogDescription>
      </DialogHeader>
      <div className="space-y-5">
        <Section title="Boarding" svc="boarding" dogs={dogs.filter((d) => d.service === "boarding")} />
        <Section title="Daycare" svc="daycare" dogs={dogs.filter((d) => d.service === "daycare")} />
        {!dogs.length && <div className="text-sm text-gray-400 py-6 text-center">No dogs checked in right now.</div>}
      </div>
    </DialogContent>
  </Dialog>
);
